import React from 'react';
import { ValidationErrors } from 'constants/validations';
import { Button, Col, Divider, Form, FormInstance, Row, Select, Tooltip, Typography } from 'components';
import { BestIcon, CheapestIcon, CloseIcon, DoneIcon, FastestIcon, LatestIcon } from 'components/common/icons';
import { useRelation } from './useRelation';
import styles from './styles.module.scss';

const { Item } = Form;
const { Text } = Typography;

export const SUPPLIER_OFFER_PRIORITIES: Record<string, any> = {
  LATEST: {
    label: 'Latest',
    icon: <LatestIcon size={12} />,
  },
  BEST: {
    label: 'Best',
    icon: <BestIcon size={12} />,
  },
  CHEAPEST: {
    label: 'Cheapest',
    icon: <CheapestIcon size={12} />,
  },
  FASTEST: {
    label: 'Fastest',
    icon: <FastestIcon size={12} />,
  },
};

export interface IRelation {
  form: FormInstance;
  relationList: Record<string, any>[];
  onSave: (relation: any) => void;
  onRemove?: (relation: any) => void;
  onEdit?: (id: string, type: string) => void;
}

export const RelationForm = (props: IRelation) => {
  // const { hasAccess } = useAccessControl();
  const { form, relationList, onSave, onRemove } = props;
  const {
    onRelationCancel,
    onRelationSave,
    isChanged,
    purchaseRequestBrand,
    supplierOffers,
    onRedirectToPurchaseRequestSupplierOffers,
  } = useRelation({
    form,
    relationList,
    onSave,
    onRemove,
  });
  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Item name="relationBrand" label={'Brand/ Purchase Request'}>
          <Select
            onChange={() => {
              form.resetFields(['relationSupplierOffer']);
            }}
            options={purchaseRequestBrand}
            size={'large'}
          />
        </Item>
      </Col>
      <Col span={12}>
        <Item noStyle shouldUpdate={(prev, curr) => prev.relationBrand !== curr.relationBrand}>
          {({ getFieldValue }) => {
            const relationBrand = getFieldValue('relationBrand');
            return (
              <Item
                name="relationSupplierOffer"
                label={'Supplier Offer*'}
                rules={[{ required: !!relationBrand, message: ValidationErrors.required('Supplier Offer') }]}
              >
                <Select
                  disabled={!relationBrand}
                  size={'large'}
                  options={supplierOffers.map((supplier: any) => ({
                    value: supplier.value,
                    disabled: relationList.some(
                      (_relation) =>
                        _relation.relationBrand === relationBrand && _relation.relationSupplierOffer === supplier.value
                    ),
                    label: (
                      <Row justify={'space-between'} align={'middle'}>
                        {supplier.label}
                        {!!supplier.priorities?.length && (
                          <Col>
                            <Row align={'middle'} className={styles.sort_item}>
                              {supplier.priorities.length > 1 ? (
                                supplier.priorities.map((_item: string) => (
                                  <Tooltip key={_item} title={SUPPLIER_OFFER_PRIORITIES[_item].label}>
                                    <Text>{SUPPLIER_OFFER_PRIORITIES[_item].icon}</Text>
                                  </Tooltip>
                                ))
                              ) : (
                                <>
                                  {SUPPLIER_OFFER_PRIORITIES[supplier.priorities[0] as string].icon}
                                  <Text className={'font-size-12 font-weight-500'}>
                                    {SUPPLIER_OFFER_PRIORITIES[supplier.priorities[0] as string].label}
                                  </Text>
                                </>
                              )}
                            </Row>
                          </Col>
                        )}
                      </Row>
                    ),
                  }))}
                  dropdownRender={() => (
                    <>
                      <Divider />
                      <Row style={{ padding: '8px' }} justify={'center'}>
                        <Button
                          type="text"
                          style={{ color: '#05796B', fontWeight: 500 }}
                          onClick={() => onRedirectToPurchaseRequestSupplierOffers(relationBrand)}
                        >
                          View Details
                        </Button>
                      </Row>
                    </>
                  )}
                />
              </Item>
            );
          }}
        </Item>
      </Col>
      <Col span={24}>
        <Row gutter={4} justify={'end'}>
          <Col>
            <Button
              disabled={!isChanged}
              color="default"
              variant="filled"
              onClick={onRelationCancel}
              icon={<CloseIcon />}
            />
          </Col>
          <Col>
            <Button onClick={onRelationSave} disabled={!isChanged} type={'primary'} icon={<DoneIcon />} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
